<template>
  <form @submit.prevent="onSubmit">
    <div class="row">
      <div class="col-12">
        <label class="form-label">
          Name <span class="text-danger">*</span>
        </label>

        <div class="mb-3">
          <input
            v-model="batchNumber.name"
            class="form-control"
            required
            type="text"
            name="name"
            placeholder="Name"
          >
        </div>
      </div>

      <div class="col-12">
        <div class="mb-3">
          <label class="form-label">
            Year <span class="text-danger">*</span>
          </label>

          <input
            v-model="batchNumber.year"
            class="form-control"
            required
            type="number"
            name="year"
            placeholder="Year"
          >
        </div>
      </div>

      <div class="col-12">
        <button
          class="btn btn-primary-green me-2"
          type="submit"
          :disabled="disabled"
        >
          <span v-html="buttonText" />
        </button>
        <button
          type="button"
          class="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Cancel
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import { BatchNumbersAPI } from '../../api/modules';

export default {
  name: 'BatchNumberForm',
  props: {
    entity: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      isSubmitting: false,
      batchNumber: {
        name: '',
        year: null
      }
    };
  },
  computed: {
    buttonText() {
      let buttonText;

      if (this.isSubmitting) {
        buttonText = this.entity ? 'Saving <i class="fas fa-spin fa-spinner ms-2"></i>' : 'Adding <i class="fas fa-spin fa-spinner ms-2"></i>';
      } else {
        buttonText = this.entity ? 'Save <i class="fas fa-save ms-2"></i>' : 'Add <i class="fas fa-plus ms-2"></i>';
      }

      return buttonText;
    },
    disabled() {
      const { name, section, serialNumber } = this.batchNumber;

      return name === '' || section === '' || serialNumber === '';
    }
  },
  watch: {
    entity() {
      this.batchNumber = JSON.parse(JSON.stringify(this.entity));
    }
  },
  created() {
    this.$emitter.on('modal.hidden', this.modalHiddenHandler);
  },
  unmounted() {
    this.$emitter.off('modal.hidden', this.modalHiddenHandler);
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      const apiMethod = this.entity
        ? () => BatchNumbersAPI.updateBatchNumber(this.batchNumber)
        : () => BatchNumbersAPI.createBatchNumber(this.batchNumber);
      const response = await apiMethod();

      if (response) {
        this.$emitter.emit(this.entity ? 'batchNumber.edited' : 'batchNumber.add', response);

        await this.$alert.success(this.entity ? 'Batch number edited' : 'Batch number added');
      }

      this.isSubmitting = false;

      this.resetForm();
    },
    resetForm() {
      this.batchNumber.name = '';
      this.batchNumber.year = null;
    },
    modalHiddenHandler(source) {
      if (source === 'batchNumberPage') {
        this.resetForm();
      }
    }
  }
};
</script>
